import React, { useState, useEffect } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import viewImage from "../../assets/images/icons/view.svg";
import editImage from "../../assets/images/icons/edit-circle-fill.svg";
import { Link, useNavigate } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import Pagination from "react-bootstrap/Pagination";
import { Button } from "react-bootstrap";

function Subscription() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [cms, setCms] = useState({ type: "publish" });
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);

  // const getList = async () => {
  //   setLoading(true);
  //   try {
  //     const query = new URLSearchParams({
  //       publish_status: cms?.type === "publish" ? 1 : 0,
  //       search,
  //       page,
  //       limit,
  //     }).toString();

  //     const response = await handleApiCall(
  //       "get",
  //       `${endpoints.teamList}?${query}`
  //     );
  //     if (response?.data?.code === 200) {
  //       setData(response?.data?.data?.team);
  //       setTotalPages(response?.data?.data?.totalPages || 1);
  //     } 
  //   } catch (error) {
  //     setError(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   getList();
  // }, [cms, page, search]);

  // const block = async (status, id) => {
  //   try {
  //     const response = await handleApiCall("put", endpoints.teamBlock, {
  //       status,
  //       teamId: id,
  //     });
  //     if (response?.data?.code === 200) {
  //       toast.success(response?.data?.data?.message || "Team status updated!");
  //       getList();
  //     }
  //   } catch (error) {
  //     toast.error("Failed to update team status.");
  //   }
  // };

  // const deleteTeam = async (id) => {
  //   if (window.confirm("Are you sure you want to delete this team?")) {
  //     try {
  //       const response = await handleApiCall(
  //         "delete",
  //         `${endpoints.teamDelete}?teamId=${id}`
  //       );
  //       if (response?.data?.code === 200) {
  //         toast.success("Team deleted successfully!");
  //         getList();
  //       } 
  //     } catch (error) {
  //       toast.error("Error deleting team.");
  //     }
  //   }
  // };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Subscription Detail</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <div className="card-heading d-flex align-items-center mb-3 pb-2">                
                <div className="d-flex align-items-center col-md-12 px-0">
                  <form className="col-md-3 px-0">
                    <div className="form-group my-0">
                      <input
                        className="form-control search-icon left-icon border"
                        placeholder="Search"
                      />
                    </div>
                  </form>
                  <Link to='/subscription/add-subscription' className="ml-auto btn btn-primary">Add New +</Link>
                </div>
              </div>
              <div className="col-md-12 tab-content row px-0 mx-0">
                <div className="table-responsive px-0">
                  <table className="table table-striped trim">
                    <thead>
                      <tr>
                        <th width="80">Subscription ID</th>
                        <th>Subscription Type</th>
                        <th>Subscription price</th>
                        <th width="150px">Action</th>
                      </tr>
                    </thead>
                    <tbody>                      
                        <tr>
                            <td>#1212989</td>
                            <td className="text-center">Basic</td>
                            <td>£423</td>
                            <td>
                              <Link to="/subscription/view-subscription"><img src={viewImage} className="mr-2"/></Link>
                              <Link to=""><img src={editImage}/></Link>
                            </td>
                        </tr>
                        <tr>
                            <td>#1212989</td>
                            <td className="text-center">Basic</td>
                            <td>£423</td>
                            <td>
                              <Link to="/subscription/view-subscription"><img src={viewImage} className="mr-2"/></Link>
                              <Link to=""><img src={editImage}/></Link>
                            </td>
                        </tr>
                        <tr>
                            <td>#1212989</td>
                            <td className="text-center">Basic</td>
                            <td>£423</td>
                            <td>
                              <Link to="/subscription/view-subscription"><img src={viewImage} className="mr-2"/></Link>
                              <Link to=""><img src={editImage}/></Link>
                            </td>
                        </tr>
                        <tr>
                            <td>#1212989</td>
                            <td className="text-center">Basic</td>
                            <td>£423</td>
                            <td>
                              <Link to="/subscription/view-subscription"><img src={viewImage} className="mr-2"/></Link>
                              <Link to=""><img src={editImage}/></Link>
                            </td>
                        </tr>
                        <tr>
                            <td>#1212989</td>
                            <td className="text-center">Basic</td>
                            <td>£423</td>
                            <td>
                              <Link to="/subscription/view-subscription"><img src={viewImage} className="mr-2"/></Link>
                              <Link to=""><img src={editImage}/></Link>
                            </td>
                        </tr>
                        {/* <tr>
                          <td colSpan="6" className="text-center py-4">
                            No Data Found
                          </td>
                        </tr> */}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* Pagination */}
              <div className="mt-4 d-flex justify-content-end">
                <Pagination>
                  <Pagination.First onClick={() => setPage(1)} disabled={page === 1} />
                  <Pagination.Prev onClick={() => setPage(page - 1)} disabled={page === 1} />
                  {[...Array(totalPages)].map((_, i) => (
                    <Pagination.Item
                      key={i + 1}
                      active={page === i + 1}
                      onClick={() => setPage(i + 1)}
                    >
                      {i + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next onClick={() => setPage(page + 1)} disabled={page === totalPages} />
                  <Pagination.Last onClick={() => setPage(totalPages)} disabled={page === totalPages} />
                </Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Subscription;
